import React from 'react';

/* Compact Soft Glass header capsule — the mark + a thin suffix label.
   On narrower widths only the mark + suffix show so the pill nav keeps room. */
export default function Logo({ size = 'md', tagline = true, variant = 'header', suffix }) {
    const box = size === 'sm' ? 26 : size === 'lg' ? 42 : 32;

    if (variant === 'plain') {
        return (
            <div className="flex items-center gap-3" data-testid="shine-logo">
                <div
                    className="flex items-center justify-center rounded-xl overflow-hidden flex-shrink-0 bg-white"
                    style={{ width: box, height: box, border: '1px solid rgba(17,20,24,.08)' }}
                >
                    <img src="/brand/shine-logo.png" alt="SHINE" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
                <div className="leading-tight">
                    <div className="text-[15px] font-semibold tracking-tight">
                        <span style={{ color: 'rgb(var(--blue))' }}>SHINE</span>{' '}
                        <span style={{ color: 'rgb(var(--green))' }}>AD AGENCY</span>
                    </div>
                    {tagline && (
                        <div className="text-[10px] uppercase tracking-[0.18em] text-ink-3">Ops Hub · Vizag</div>
                    )}
                </div>
            </div>
        );
    }

    // Header capsule — compact: logo mark + optional suffix label only.
    // The full "SHINE AD AGENCY" wordmark lives in the Login/plain variant.
    return (
        <div
            className="inline-flex items-center gap-2 pl-1.5 pr-3 py-1 rounded-pill bg-white flex-shrink-0"
            style={{ border: '1px solid rgba(17,20,24,.08)' }}
            data-testid="shine-logo"
        >
            <div
                className="flex items-center justify-center rounded-lg overflow-hidden flex-shrink-0 bg-white"
                style={{ width: box, height: box }}
            >
                <img src="/brand/shine-logo.png" alt="SHINE AD AGENCY" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
            {suffix && (
                <span className="text-[13px] font-medium text-ink-2 whitespace-nowrap pl-1 pr-1">{suffix}</span>
            )}
        </div>
    );
}
